import apiClient from '@u/apiClient'

export default {
  registerCompanyToPeppol({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .post(`company/${payload.id}/peppol/register`, payload.params)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  checkCompanyReady({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`company/${payload.id}/peppol/check`, payload.params)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  checkPeppolInvoiceable({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .post(`peppol/check-invoiceable`, payload.params)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  sendInvoiceViaPeppol({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .post(`invoicing/${payload.id}/peppol/send`, payload.params)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
